<template>
  <main>
    <iframe
      ref="popup"
      :src="$options.src"
      style="height: 100vh; width: 100vw;"
      title="Simulator"
    />
  </main>
</template>

<script>
import Cookies from 'js-cookie';
import { getCoacOrigin } from '../utils/destinationManager';

export default {
  name: 'Simulator',
  data() {
    return {
      coa: {},
      viewAt: '',
    };
  },
  src: `${getCoacOrigin(window.location.href)}/mgoc/simulator/v2`,
  created() {
    const callback = async (event) => {
      if (event.origin !== window.origin) {
        const {
          type,
          coa,
          cuid,
          cfpsid,
          destination,
          config,
          ampersendViewAt,
        } = event.data;
        if (type === 'simulator') {
          this.$store.set('config', config);
          await this.setCOA(coa);
          this.setCFPSID(cfpsid || '');
          this.coa.cuid = cuid;
          this.viewAt = ampersendViewAt;

          this.goto(destination);
        }
      }
    };
    window.addEventListener('message', callback, false);
  },
  methods: {
    async setCOA(uuid) {
      this.$coa.coaUUID = uuid;
      Cookies.set('coa', this.$coa.coaUUID, {
        expires: 2 / 24, // 2 hours
        sameSite: 'strict',
      });
      this.coa = await this.$coa.coaGet();
    },
    setCFPSID(cfpsid) {
      Cookies.set('coa_complete', cfpsid, {
        sameSite: 'strict',
      });
    },
    async identifyWithOfferService() {
      this.$store.set('instantSavings/token', this.$coa.token);
      this.$store.set('instantSavings/orderUuid', this.$coa.coaUUID);
      await this.$store.dispatch('instantSavings/identify', this.coa.informedDelivery);
      await this.$store.dispatch(
        'instantSavings/getOffers',
        {
          schemas: ['MGO Advantage Single', 'MGO Advantage Double'],
          viewAt: new Date(this.viewAt).toISOString(),
        },
      );
    },
    async goto(oldRoute) {
      if (oldRoute.indexOf('instant-savings') >= 0) {
        this.$router.push({ name: 'action', query: { cuid: this.coa.cuid, coa_uuid: this.$coa.coaUUID, viewAt: this.viewAt } });
        return;
      }

      switch (oldRoute) {
        case '/move-combined':
          this.$router.push({ name: 'move-combined' });
          break;

        case '/verify-info':
          this.$router.push({ name: 'verify-info-read' });
          break;

        case '/identity-check':
        case '/age-verification':
          this.$router.push({ name: 'identity-check' });
          break;

        case '/confirm-order':
          this.$router.push({ name: 'confirm-order' });
          break;

        case '/confirm-order-mcoa':
          break;

        case '/military-confirmation':
          break;

        default:
          this.$router.push({ name: 'home' });
      }
    },
  },
};
</script>
